import React, { lazy, useEffect, useState } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { authPages, publicPages } from '../../routes/contentRoutes';
import { useSelector } from 'react-redux';
import Loader from '../../components/common/DotLoader';

const PAGE_404 = lazy(() => import('../../pages/presentation/auth/Page404'));

interface RouteData {
  path: string;
  element: React.ReactNode;
}

const ContentRoutes = () => {
  const [contents, setContent] = useState<RouteData[] | null>(null);
  const [isLoading, setLoading] = useState(true);
  const currentEmployee = useSelector((state: any) => state.employee.currentEmployee);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem('token');

    if (token) {
      if (location.pathname === '/login') {
        navigate('/', { replace: true });
        return;
      }

      if (!currentEmployee || !currentEmployee?.data?.permissions) {
        setLoading(true);
        return;
      }

      const menu = currentEmployee.data?.permissions;
      const filteredAuth = authPages?.filter((route) => {
        const { path } = route;
        return Object.values(menu).some((submenu) => {
          return Object.values(submenu).some((item: any) => {
            return Object.values(item)?.some((subItem: any) => {
              return subItem.path === path;
            });
          });
        });
      });

      //@ts-ignore
      setContent([...filteredAuth, ...publicPages]);
      setLoading(false);
    } else {
      setContent(publicPages);
      setLoading(false);
      if (location.pathname !== '/login') {
        navigate('/login');
      }
    }
  }, [currentEmployee, navigate, location]);

  if (isLoading) {
    return <Loader isLoading={true} />;
  }

  if (!contents) {
    return null;
  }

  return (
    <Routes>
      {contents.map((page) => (
        <Route key={page.path} path={page.path} element={page.element} />
      ))}
      <Route path='*' element={<PAGE_404 />} />
    </Routes>
  );
};

export default ContentRoutes;